import { Alert, Button } from "@mui/material";

export const ReviewsMessage = ({
  message = "No reviews yet.",
  icon,
  type = "info",
  onRetry,
}) => (
  <Alert
    severity={type === "error" ? "error" : "info"}
    sx={{
      width: "100%",
      "& .MuiAlert-message": { display: "flex", alignItems: "center", gap: 1 },
    }}
    icon={icon || undefined}
    action={
      onRetry && (
        <Button color="inherit" onClick={onRetry}>
          Refresh
        </Button>
      )
    }
  >
    {message}
  </Alert>
);